import React from 'react'
import { Button } from '@/components/buttons/Button'

export const DateRangePickerClear = ({ clearButtonLabel, disabled, handleClear }) => {
  return (
    <div className="date-picker-clear-section" data-testid="date-picker-clear-section">
      <Button
        disabled={disabled}
        onClick={handleClear}
        data-testid="clear"
        className="date-picker-clear-section__button"
      >
        {clearButtonLabel || 'Clear Results'}
      </Button>
    </div>
  )
}
